/** The zones offered in pickers: North America first, since that is who is mailed. */
const COMMON_TIMEZONES: { zone: string; label: string }[] = [
  { zone: "America/New_York", label: "Eastern (New York)" },
  { zone: "America/Chicago", label: "Central (Chicago)" },
  { zone: "America/Denver", label: "Mountain (Denver)" },
  { zone: "America/Phoenix", label: "Arizona (Phoenix, no DST)" },
  { zone: "America/Los_Angeles", label: "Pacific (Los Angeles)" },
  { zone: "America/Anchorage", label: "Alaska (Anchorage)" },
  { zone: "Pacific/Honolulu", label: "Hawaii (Honolulu)" },
  { zone: "America/Puerto_Rico", label: "Atlantic (Puerto Rico)" },
  { zone: "America/Halifax", label: "Atlantic (Halifax)" },
  { zone: "America/Toronto", label: "Eastern (Toronto)" },
  { zone: "America/Vancouver", label: "Pacific (Vancouver)" },
  { zone: "Europe/London", label: "London" },
  { zone: "UTC", label: "UTC" },
];

/** A <select> of the common zones, keeping a current value that is not among them. */
export function TimezoneSelect({
  id,
  value,
  onChange,
  allowBlank,
  blankLabel = "Not set",
}: {
  id?: string;
  value: string;
  onChange: (zone: string) => void;
  allowBlank?: boolean;
  blankLabel?: string;
}) {
  const known = COMMON_TIMEZONES.some((z) => z.zone === value);
  return (
    <select id={id} value={value} onChange={(e) => onChange(e.target.value)}>
      {allowBlank && <option value="">{blankLabel}</option>}
      {!known && value && <option value={value}>{value}</option>}
      {COMMON_TIMEZONES.map((z) => (
        <option key={z.zone} value={z.zone}>
          {z.label}
        </option>
      ))}
    </select>
  );
}
